import { translate } from 'src/app/project/features/translate/translate';

export function getEmptyGroupName(): string {
  return '(' + translate('empty') + ')';
}
